<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)"  @click="urlTo('applyIndex')">个人办事</a> / <span>{{title}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div  class="wraper">
          <div class="publicity">

            <div class="division1" >

              <span>所在区划：
          <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"  clearable placeholder="请选择所在区划" style="width: 160px;"></el-cascader>
          </span>

            </div>
            <div style="height: 100px">&nbsp;</div>
            <div  v-loading="loading" v-if="dataList.length>0">

              <table  width="100%" border="0" cellspacing="1" cellpadding="0">
                <tr class="first">
                  <td width="150">机构名称</td>
                  <td width="150px">所属区划</td>
                  <td width="100">类型</td>
                  <td>地址</td>
                  <td width="70">操作</td>
                </tr>
                <tr  v-for="(item,index) in dataList" :key="index">
                  <td align="left" style="width: 384px;text-align: center" nowrap="true">{{item.organName}}</td>
                  <td align="center" nowrap="true">{{item.areaName}}</td>
                  <td align="center" nowrap="true">{{item.organTypeName}}</td>
                  <td align="center" nowrap="true">{{item.address}}</td>
                  <td align="center" nowrap="true">
                    <el-button size="small"  @click="urlTo('institutionalQueryDetail',{data:item,title:title,yyType:yyType,joinType:'apply'})" type="info">详情</el-button>
                    <el-button size="small" :disabled="item.canBookCar && item.canBookCar=='0'"  @click="urlTo('organinfoListSubmit',{data:item,title:title,yyType:yyType})" type="primary">预约</el-button>
                  </td>
                </tr>
              </table >
              <div style="text-align: center;height: 50px;line-height: 50px;" v-if="dataList.length>0"> <el-pagination
                layout="prev, pager, next"
                :total="total" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
              </el-pagination>
              </div>

            </div>
            <div v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                <div>暂无数据</div>
              </div>
            </div>
</div>

        </div>

      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  let id = 0;

  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      let _self=this;
      return {
        dataObjList:[],
        dataList:[],
        itemMonth:'',
        opType:'',
        loading:false,
        showClause:false,
        title:'',
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        type:'',
        tabSelect:'apply',
        workDepartId:"",
        total:1,
        registryType:[],
        timeList:[],
        pname:"",
        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value='630000';
              t=1;
              //上级为空，默认设置大通县数据
            }
            /*    else if (node.value.length>8){
                  return
                }*/
            const options={areaCode:node.value}
            _self.$https.post("api/marriage/getAreaInfo.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.areaName, value: e.areaCode, level: 0, leaf: level >= 1}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        selectedRegion:[],
        yyType:'',
        apply_source:'2',
        selecteddylbOption:[],
        departOption:[],
        pageNum:1,
        pageSize:10,
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },

      selectedRegion(nv){
        this.selectTimeAppointment();
      },

    },
    created(){
      this.yyType= this.$route.query.yyType;
      this.title = this.$route.query.title;
      this.selectTimeAppointment();
    },
    methods: {


      nextClieck(a){
        this.pageNum=this.pageNum+1;
        this.selectTimeAppointment();
      },
      pageChange(a){
        this.pageNum=a
        this.selectTimeAppointment();
      },
      prevClick(a){
        this.pageNum=this.pageNum-1;
        this.selectTimeAppointment();
      },
      selectTimeAppointment(){
        var _wdid='';
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        /*this.loading=true;*/
        const options={
          areaCode:_wdid,
          yyType:this.yyType,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
        }


        this.$https.post("api/ywt/apply/organInfoYy.do",options,response=>{
          if (response.status === 200 && response.data.code===200&&response.data.data.dataList.length>0) {
            this.dataList=response.data.data.dataList;
            this.total=response.data.data.total;
          }else {
            this.dataList=[];
          }
          this.loading=false;
        })
      },

      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      }
    }
  }



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/OrganinfoList.vue